import {Location} from 'history';
import React, {useEffect, useState} from 'react';
import {Prompt} from 'react-router-dom';
import {IonAlert} from "@ionic/react";
import {useTranslation} from "react-i18next";

interface Props {
    when?: boolean | undefined;
    navigate: (path: string) => void;
    shouldBlockNavigation: (location: Location) => boolean;
    isOpen?: boolean;
    onClose?: () => void;
}

const PageLeavingGuard = ({
                              when,
                              navigate,
                              shouldBlockNavigation,
                              isOpen: externalIsOpen,
                              onClose,
                          }: Props) => {
    const [modalVisible, setModalVisible] = useState(false);
    const [lastLocation, setLastLocation] = useState<Location | null>(null);
    const [confirmedNavigation, setConfirmedNavigation] = useState(false);

    const closeModal = () => {
        setModalVisible(false);
        if (onClose) onClose();
    };

    const handleBlockedNavigation = (nextLocation: Location): boolean => {
        if (!confirmedNavigation && shouldBlockNavigation(nextLocation)) {
            setModalVisible(true);
            setLastLocation(nextLocation);
            return false;
        }
        return true;
    };

    const handleConfirmNavigationClick = () => {
        setModalVisible(false);
        if (onClose) onClose();
        setConfirmedNavigation(true);
    };

    useEffect(() => {
        if (confirmedNavigation) {
            navigate(lastLocation?.pathname ?? '');
            setConfirmedNavigation(false);
        }
    }, [confirmedNavigation]);

    useEffect(() => {
        if (externalIsOpen) {
            setConfirmedNavigation(false);
            setLastLocation(null);
        }
    }, [externalIsOpen]);

    const {t} = useTranslation();

    return (
        <>
            <Prompt when={when} message={handleBlockedNavigation}/>
            <IonAlert
                isOpen={modalVisible || (externalIsOpen ?? false)}
                onDidDismiss={() => closeModal()}
                header={t('reportPage.backAlert.title')}
                buttons={[
                    {
                        text: t('common.alertCancel'),
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => {

                        }
                    },
                    {
                        text: t('reportPage.backAlert.discard'),
                        handler: async () => {
                            closeModal()
                            handleConfirmNavigationClick();
                        }
                    }
                ]}
            />
        </>
    );
};
export default PageLeavingGuard;
